
export const imgServerUrl = 'http://47.104.77.229:8081/prod-api/';
export const uploadUrl = 'http://47.104.77.229:8081/prod-api/';
export const baseServerUrl = 'http://47.104.77.229:8081/prod-api/';
export const shareWebUrl = 'http://47.104.77.229:8081/prod-api/';

// export const imgServerUrl = 'https://www.qdbxxh.com/prod-api/';
// export const uploadUrl = 'https://www.qdbxxh.com/prod-api/';
// export const baseServerUrl = 'https://www.qdbxxh.com/prod-api/';
// export const shareWebUrl = 'https://www.qdbxxh.com/prod-api/';



